function formatTimeAgo(dateString) {
  if (!dateString) return '';
  const date = new Date(dateString);
  if (Number.isNaN(date.getTime())) return dateString;

  const diffMs = Math.max(0, Date.now() - date.getTime());
  const diffSeconds = Math.floor(diffMs / 1000);
  const diffMinutes = Math.floor(diffMs / (1000 * 60));
  const diffHours = Math.floor(diffMs / (1000 * 60 * 60));
  const diffDays = Math.floor(diffMs / (1000 * 60 * 60 * 24));

  if (diffSeconds < 60) return `${Math.max(diffSeconds, 1)} sec ago`;
  if (diffMinutes < 60) return `${diffMinutes} min ago`;
  if (diffHours < 24) return `${diffHours} hr ago`;
  if (diffDays < 7) return `${diffDays} day${diffDays > 1 ? 's' : ''} ago`;

  return date.toLocaleDateString('en-IN', { day: 'numeric', month: 'short', year: 'numeric' });
}

function getInitials(name) {
  const parts = String(name || '')
    .trim()
    .split(/\s+/)
    .filter(Boolean);
  if (!parts.length) return '?';
  if (parts.length === 1) return parts[0].charAt(0).toUpperCase();
  return `${parts[0].charAt(0)}${parts[1].charAt(0)}`.toUpperCase();
}

function mapDiscussionItem(item, { type, currentUserId }) {
  const isOwner = currentUserId != null && item.user_id === currentUserId;

  return {
    id: item.id,
    type,
    questionId: type === 'answer' ? item.question_id : item.id,
    author: item.user_name || 'User',
    avatar: item.user_profile_image_url || '',
    initials: getInitials(item.user_name),
    isExpert: item.author_role === 'teacher' || Boolean(item.instructor_id),
    isCorrectAnswer: item.answer_tag === 'correct',
    isPinned: Boolean(item.pinned),
    timeAgo: formatTimeAgo(item.created_at),
    text: item.content || '',
    likes: item.likes_count ?? 0,
    dislikes: item.dislikes_count ?? 0,
    replies: type === 'question' ? item.answers_count ?? 0 : 0,
    userReaction: item.user_reaction ?? null,
    canEdit: isOwner,
    canDelete: isOwner,
    canPin: type === 'question' && isOwner,
    repliesList: [],
  };
}

export function mapAnswer(answer, currentUserId) {
  return mapDiscussionItem(answer, { type: 'answer', currentUserId });
}

export function mapQuestion(question, answers = [], currentUserId) {
  const mapped = mapDiscussionItem(question, { type: 'question', currentUserId });
  mapped.repliesList = answers.map((answer) => mapAnswer(answer, currentUserId));
  mapped.replies = question.answers_count ?? mapped.repliesList.length;
  return mapped;
}

export async function mapQuestionsWithAnswers(questions, fetchAnswers, currentUserId) {
  if (!questions?.length) return [];

  const detailed = await Promise.all(
    questions.map(async (question) => {
      try {
        const response = await fetchAnswers(question.id);
        const answers = response?.data?.answers || response?.answers || [];
        return mapQuestion(question, answers, currentUserId);
      } catch {
        return mapQuestion(question, [], currentUserId);
      }
    })
  );

  return detailed;
}
